import { Controller } from "@hotwired/stimulus"
import "trix"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.editor = this.element.querySelector("trix-editor")
    if (!this.editor) return
    this.onChange = () => { this.inputTarget.value = this.editor.innerHTML }
    this.onFile = event => event.preventDefault()
    this.editor.addEventListener("trix-change", this.onChange)
    this.editor.addEventListener("trix-file-accept", this.onFile)
    const attachmentButton = this.editor.toolbarElement?.querySelector('[data-trix-action="attachFiles"]')
    if (attachmentButton) attachmentButton.hidden = true
  }

  disconnect() {
    this.editor?.removeEventListener("trix-change", this.onChange)
    this.editor?.removeEventListener("trix-file-accept", this.onFile)
  }
}
